import { SvgProps } from "../../types";

const User = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}>
    <path
      fill={props.fill ? props.fill : "#666D87"}
      d="M8.093 8.125c-1.031 0-1.914-.367-2.649-1.102-.734-.734-1.101-1.617-1.101-2.648 0-1.031.367-1.914 1.101-2.648C6.18.992 7.062.625 8.093.625s1.914.367 2.648 1.102c.735.734 1.102 1.617 1.102 2.648 0 1.031-.367 1.914-1.102 2.648-.734.735-1.617 1.102-2.648 1.102Zm-7.5 7.5V13c0-.531.136-1.02.41-1.465a2.734 2.734 0 0 1 1.09-1.02 13.917 13.917 0 0 1 2.953-1.09c1-.241 2.016-.363 3.047-.363 1.031 0 2.047.122 3.047.364s1.984.605 2.953 1.09c.453.234.816.574 1.09 1.02.273.444.41.933.41 1.464v2.625h-15Zm1.875-1.875h11.25V13a.913.913 0 0 0-.469-.797 12.216 12.216 0 0 0-2.555-.95 10.877 10.877 0 0 0-5.203 0c-.86.212-1.71.528-2.554.95a.912.912 0 0 0-.47.797v.75Zm5.625-7.5c.515 0 .957-.184 1.324-.55.367-.368.55-.81.55-1.325 0-.516-.183-.957-.55-1.324A1.805 1.805 0 0 0 8.093 2.5c-.516 0-.957.184-1.324.55-.368.368-.551.81-.551 1.325 0 .516.183.957.55 1.324.368.367.81.551 1.325.551Z"
    />
  </svg>
);
export default User;
